<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="耳标编号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="tagsNumber">
              <a-input-number v-model="model.tagsNumber" placeholder="请输入耳标编号" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="耳标类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="tagsType">
              <j-dict-select-tag type="radio" v-model="model.tagsType" dictCode="tags_type" placeholder="请选择耳标类型"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="当前状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="statusing">
              <j-dict-select-tag type="radio" v-model="model.statusing" dictCode="tag_statusing" placeholder="请选择当前状态"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="所属养殖户" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="useUserId">
              <!--              <j-dict-select-tag type="radio" v-model="model.useUserId" dictCode="tag_statusing" placeholder="请选择当前状态"/>-->
              <j-select-multi-user :multiple="false" v-model="model.useUserId" placeholder="请选择所属养殖户"
                                   :url="{list:'/sys/user/list2'}"></j-select-multi-user>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'BeefTagsForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: { tagsType: '1', statusing: '1', useUserId: '1594502737133322242' },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          tagsNumber: [{ required: true, message: '请输入耳标号' }]
        },
        url: {
          add: '/beef/beefTags/add',
          edit: '/beef/beefTags/edit',
          queryById: '/beef/beefTags/queryById'
        }
      }
    },
    computed: {
      formDisabled() {
        return this.disabled
      }
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      add() {
        this.edit(this.modelDefault)
      },
      edit(record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm() {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            if ((parseInt(this.model.tagsNumber) + '').length !== 15) {
              this.$message.warning('耳标号必须是15位纯数字')
              return
            }
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }

        })
      }
    }
  }
</script>